webpackJsonp([84254056129083],{

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsCookie = __webpack_require__(72);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _ramda = __webpack_require__(38);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _helpers = __webpack_require__(33);
	
	var _TumblrBackground = __webpack_require__(65);
	
	var _TumblrBackground2 = _interopRequireDefault(_TumblrBackground);
	
	var _Main = __webpack_require__(44);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Genevieve
	 */
	
	var sizes = ['hd', 'large', 'medium', 'small'];
	var videoCount = 3;
	var videoRoot = 'https://luckyme-public.s3.amazonaws.com/littlebabyangel/genevieve-video/';
	var videoPrefix = 'gen_';
	var suffixes = ['mp4', 'webm', 'jpg'];
	
	var videos = _ramda2.default.reduce(function (acc, size) {
	  return _ramda2.default.assoc(size, _ramda2.default.times(function (number) {
	    return _ramda2.default.map(function (suffix) {
	      return '' + videoRoot + videoPrefix + (number + 1) + '-' + size + '.' + suffix;
	    })(suffixes);
	  })(videoCount), acc);
	}, {})(sizes);
	
	var Genevieve = function (_React$Component) {
	  _inherits(Genevieve, _React$Component);
	
	  function Genevieve(props) {
	    _classCallCheck(this, Genevieve);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.isMobile = function () {
	      if (window.innerWidth >= 1024) {
	        _this.setState({
	          isMobile: false
	        });
	      } else if (window.innerWidth <= 480) {
	        _this.setState({
	          isMobile: true
	        });
	      }
	    };
	
	    _this.openPageUrlMobile = function (url) {
	      window.open(url, "_blank");
	    };
	
	    _this.setVideoSources = _this.setVideoSources.bind(_this);
	    _this.playVideo = _this.playVideo.bind(_this);
	    _this.watchScroll = _this.watchScroll.bind(_this);
	    _this.onVideoPlay = _this.onVideoPlay.bind(_this);
	    _this.registerVideoRef = _this.registerVideoRef.bind(_this);
	
	    _this.state = {
	      playing: false
	
	    };
	    return _this;
	  }
	
	  Genevieve.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    window.addEventListener("resize", function () {
	      return _this2.isMobile();
	    }, true);
	    this.setState({
	      isTumblrBackgroundOpen: true
	    });
	    document.documentElement.scrollTop = 0;
	    this.calculate();
	    window.addEventListener('scroll', this.watchScroll);
	    this.setVideoSources();
	
	    if (window.innerWidth <= 480) {
	      window.open(this.state.mobileSource);
	    }
	  };
	
	  Genevieve.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _this3 = this;
	
	    this.setState({
	      isTumblrBackgroundOpen: false
	    });
	    window.removeEventListener('scroll', this.watchScroll);
	    window.removeEventListener('resize', function () {
	      return _this3.isMobile();
	    }, true);
	  };
	
	  Genevieve.prototype.onVideoPlay = function onVideoPlay() {
	    this.setState({
	      playing: true,
	      needsInteraction: false
	    });
	  };
	
	  Genevieve.prototype.setVideoSources = function setVideoSources() {
	    var _this4 = this;
	
	    // Select randomly from the remaining video versions
	    var cookie = _jsCookie2.default.get('gen-videos-played');
	    var videosPlayed = cookie ? cookie.split(',') : [];
	    if (videosPlayed.length === 3) videosPlayed = [];
	    if (videosPlayed.length === 3) _jsCookie2.default.remove('gen-videos-played');
	
	    var videosRemaining = videosPlayed.length === 3 ? ['1', '2', '3'] : _ramda2.default.reject(function (n) {
	      return _ramda2.default.contains(n, videosPlayed);
	    }, ['1', '2', '3']);
	
	    var videoToPlay = videosRemaining[Math.floor(Math.random() * videosRemaining.length)];
	    _jsCookie2.default.set('gen-videos-played', _ramda2.default.join(',', _ramda2.default.append(videoToPlay, videosPlayed)));
	
	    // Select the source first by window size, then by the video to play
	    var size = window.outerWidth > 1024 ? 'hd' : window.outerWidth > 720 ? 'large' : window.outerWidth > 480 ? 'medium' : 'small';
	
	    var sources = videos[size][videoToPlay - 1];
	    this.setState({
	      playing: false,
	      sources: sources
	    }, function () {
	      _this4.video.load();
	      _this4.playVideo();
	    });
	  };
	
	  Genevieve.prototype.playVideo = function playVideo() {
	    var _this5 = this;
	
	    if (!this.video) return;
	    this.video.play().then(function () {
	      _this5.setState({ playing: true });
	    }).catch(function (err) {
	      _this5.setState({
	        needsInteraction: true
	      });
	    });
	  };
	
	  Genevieve.prototype.registerVideoRef = function registerVideoRef(element) {
	    this.video = element;
	    this.playVideo();
	  };
	
	  Genevieve.prototype.watchScroll = function watchScroll() {
	    if (!this.mainContainer) return;
	    var scrollTop = pageYOffset || document.body.scrollTop;
	    if (scrollTop >= this.mainContainer.scrollHeight) {
	      this.props.history.push('/');
	    }
	  };
	
	  Genevieve.prototype.calculate = function calculate() {
	    var _this6 = this;
	
	    clearTimeout(this.debounceTimer);
	    this.debounceTimer = setTimeout(function () {
	      var body = { document: document };
	      var html = document.documentElement;
	      _this6.windowHeight = window.innerHeight || html.clientHeight || body.clientHeight;
	      _this6.documentHeight = _this6.mainContainer.scrollHeight;
	    }, 250);
	  };
	
	  Genevieve.prototype.render = function render() {
	    var _this7 = this;
	
	    if (!this.state.sources) return null;
	    var classNames = ['genevieve'];
	    if (this.state.complete) classNames.push('cartier--complete');
	    if (this.state.needsInteraction) classNames.push('needsInteraction');
	    var videoClassNames = ['videoFrame', 'videoFrame--full'];
	    videoClassNames.push(this.state.playing ? 'video--playing' : 'video--loading');
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'section',
	        { ref: function ref(element) {
	            _this7.mainContainer = element;
	          }, className: (0, _helpers.cn)(classNames) },
	        _react2.default.createElement(
	          'button',
	          { className: 'videoPlay', onClick: function onClick() {
	              return _this7.playVideo();
	            } },
	          _react2.default.createElement('span', null)
	        ),
	        this.state.isMobile ? _react2.default.createElement(
	          'div',
	          { className: (0, _helpers.cn)(videoClassNames) },
	          _react2.default.createElement('img', { src: '/images/logo-eye.png', alt: 'LuckyMe', className: 'loading-eye' }),
	          _react2.default.createElement(
	            'video',
	            {
	              poster: this.state.sources[2]
	            },
	            _react2.default.createElement('source', { src: this.state.sources[0], type: 'video/webm' }),
	            _react2.default.createElement('source', { src: this.state.sources[1], type: 'video/mp4' })
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _helpers.cn)(videoClassNames) },
	          _react2.default.createElement('img', { src: '/images/logo-eye.png', alt: 'LuckyMe', className: 'loading-eye' }),
	          _react2.default.createElement(
	            'video',
	            {
	              ref: this.registerVideoRef,
	              poster: this.state.sources[2],
	              onPlay: this.onVideoPlay,
	              src: this.state.sources[0]
	            },
	            _react2.default.createElement('source', { src: this.state.sources[0], type: 'video/webm' }),
	            _react2.default.createElement('source', { src: this.state.sources[1], type: 'video/mp4' })
	          )
	        )
	      ),
	      _react2.default.createElement(_Main2.default, _extends({ emailLogo: this.props.data.allContentfulLuckymeLba.edges[0].node.meta.emailLogo.file.url }, this.props.data.allContentfulLuckymeLba.edges[0].node.content, { tumblr: this.props.data.allTumblrAssets.edges }))
	    );
	  };
	
	  return Genevieve;
	}(_react2.default.Component);
	
	Genevieve.propTypes = {
	  // title: PropTypes.string
	};
	
	Genevieve.defaultProps = {
	  // title: 'My Title'
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Genevieve;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-genevieve-js-620c38397489960d2b30.js